import { ContactKind, PersonModel } from '@ail/customers-api'
import './ContactListItem.scss'
interface Props {
  person: PersonModel
  onClick: (val: boolean) => void
}
export default function ContactListItem({ person, onClick }: Props) {
  const contactInfo = person.contacts.filter((c) =>
    [ContactKind.PhoneNumber, ContactKind.Email, ContactKind.MobileNumber].includes(c.kind)
  )
  const contactData = {
    displayName: person.displayName,
    phoneNumber: contactInfo.find((c) => c.kind === ContactKind.PhoneNumber)?.value || null,
    email: contactInfo.find((c) => c.kind === ContactKind.Email)?.value || null,
    mobileNumber: contactInfo.find((c) => c.kind === ContactKind.MobileNumber)?.value || null,
  }
  const noPhone = !contactData.mobileNumber && !contactData.phoneNumber
  return (
    <li onClick={() => onClick(noPhone)} className="contactListItem" key={Math.random()}>
      <div className="contentBox">
        <i className="icon-manager"></i>
        <span style={noPhone ? { color: ' #ed3115' } : undefined}>{contactData.displayName}</span>
      </div>
      <div className="contactsDetails">
        {contactData.phoneNumber && (
          <span>
            <i className="icon-phone" /> {contactData.phoneNumber}
          </span>
        )}
        {contactData.email && (
          <span>
            <i className="icon-mail" />
            <span style={noPhone ? { color: ' #ed3115' } : undefined}>{contactData.email}</span>
          </span>
        )}
        {contactData.mobileNumber && (
          <span>
            <i className="icon-mobile" /> {contactData.mobileNumber}
          </span>
        )}
      </div>
    </li>
  )
}
